<style lang="scss">
  @import '../resources/scss/library_button.scss';
</style>

<script lang="ts">
  import MediaQuery from './MediaQuery.svelte'
  import { ScreenSizes } from '../config/screen_sizes'
  import { commonWebsiteData } from '../stores/stores'
  import type LibraryWidget from '../api/rest/directus-cms/app/models/LibraryWidget'
  import { onDestroy } from 'svelte'

  let librarySectionData: LibraryWidget

  const unsubscribeWebsiteData = commonWebsiteData.subscribe(data => {
    if (data?.library_widget) librarySectionData = data.library_widget
  })

  onDestroy(() => {
    unsubscribeWebsiteData()
  })
</script>

{#if librarySectionData}
  <a href={librarySectionData.link} target="_blank" rel="noopener noreferrer">
    <button class="rectangle_btn px-4">
      <MediaQuery query="(max-width: {ScreenSizes.MD_MAX_WIDTH}px)" let:matches>
        {#if matches}
          <div class="library-container d-flex">
            <img
              src={librarySectionData.image?.fullUrl}
              alt={librarySectionData.small_title}
            />
            <span class="h4 mb-0 ms-3 library-text">{librarySectionData.small_title}</span
            >
          </div>
        {:else}
          <div class="library-container d-flex">
            <img
              src={librarySectionData.image?.fullUrl}
              alt={librarySectionData.small_title}
            />
            <span class="h4 mb-0 ms-3 library-text">{librarySectionData.small_title}</span
            >
          </div>
        {/if}
      </MediaQuery>
    </button>
  </a>
{/if}
